import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AlertCircle, RefreshCw, ArrowLeft, ShieldAlert } from 'lucide-react';

export const PaymentFailedPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const stateData = (location.state as any) || {};
  const orderId = stateData.orderId || stateData.order_id || 'order_failed';
  const failureReason = stateData.failureReason || stateData.error || 'Payment was declined or cancelled by bank.';
  const returnTo = stateData.returnTo || '/membership';

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-3xl border border-rose-200 shadow-xl p-6 sm:p-8 text-center space-y-6 animate-in zoom-in-95">
        
        {/* Failed Emblem */}
        <div className="w-20 h-20 rounded-full bg-rose-100 text-rose-600 flex items-center justify-center mx-auto shadow-inner">
          <AlertCircle className="w-12 h-12" />
        </div>

        {/* Text requested by user */}
        <div className="space-y-1.5">
          <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-bold bg-rose-100 text-rose-800 border border-rose-300">
            <ShieldAlert className="w-3.5 h-3.5" /> Gateway Rejected
          </span>
          <h2 className="text-2xl sm:text-3xl font-black text-slate-900">
            ✕ Payment Failed
          </h2>
          <p className="text-sm font-semibold text-rose-700">
            Your payment could not be completed.
          </p>
          <p className="text-xs text-slate-500 mt-1">
            {failureReason}
          </p>
        </div>

        {/* Order Details */}
        <div className="p-4 bg-slate-50 rounded-2xl border border-slate-200 text-left text-xs space-y-2">
          <div className="flex items-center justify-between">
            <span className="text-slate-500">Order ID:</span>
            <span className="font-mono text-slate-800">{orderId}</span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-slate-500">Status:</span>
            <span className="font-bold text-rose-600">FAILED / NOT CAPTURED</span>
          </div>
          <div className="flex items-center justify-between pt-2 border-t border-slate-200">
            <span className="text-slate-500">Membership:</span>
            <span className="font-bold text-slate-700">INACTIVE (No charges made)</span>
          </div>
        </div>

        {/* Try Again button */}
        <div className="space-y-2 pt-2">
          <button
            type="button"
            onClick={() => navigate(returnTo, { replace: true })}
            className="w-full py-3.5 bg-gradient-to-r from-purple-700 via-purple-800 to-indigo-800 hover:from-purple-800 hover:to-indigo-900 text-white font-extrabold text-sm rounded-xl shadow-md transition-all flex items-center justify-center gap-2 cursor-pointer"
          >
            <RefreshCw className="w-4 h-4" />
            <span>Try Again</span>
          </button>

          <button
            type="button"
            onClick={() => navigate('/dashboard')}
            className="w-full py-2.5 bg-slate-100 hover:bg-slate-200 text-slate-700 font-bold text-xs rounded-xl transition-colors cursor-pointer"
          >
            Back to Dashboard
          </button>
        </div>

      </div>
    </div>
  );
};
